import React from "react";
import EditUserLayer from "../components/EditUserLayer";

const EditUserPageList = () => {
  return <EditUserLayer />;
};

export default EditUserPageList;
